import axios from '@interfaces/axios.js'

/**
 * ----------------------------------------------------
 * @path    
 * @method POST
 * @desc   
 * 
 * @date   2020-09-17 
 * ----------------------------------------------------
 */
export function fileverifyForm(obj) {
    let {
        file,
        onUploadProgress
    } = obj

    let formdata = new FormData()
    
    formdata.append("file", file)

    return axios.post(`/api/verifiers/form-verify`, formdata, {
        onUploadProgress
    })
}
